module.exports = __webpack_public_path__ + "img/yayixx1.f5b4a080.png";